import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/image-in-error-page.svg")